h2.schedulingTitle {
  padding-bottom: 0;
  margin-top: 2rem;
}
